import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import store from "./store/store";
import VueGtag from "vue-gtag";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
require("@/assets/css/style-resultados.css");
Vue.use(BootstrapVue);
Vue.config.productionTip = false;

new Vue({
  el: "#app",
  store,
  router,
  template: "<App/>",
  components: { App }
});

Vue.use(
  VueGtag,
  {
    config: {
      id: GTAG_ANALYTICS_KEY
    }
  },
  router
);



// WEBPACK FOOTER //
// ./src/main.js